export const translations = {
  'Start': { EN: 'Start', UR: 'اسٹارٹ' },
  'Search': { EN: 'Search', UR: 'تلاش' },
  'Home': { EN: 'Home', UR: 'ہوم' },
  'Name': { EN: 'Name', UR: 'نام' },
  'Type': { EN: 'Type', UR: 'قسم' },
  'Role': { EN: 'Role', UR: 'کردار' },
  'Description': { EN: 'Description', UR: 'تفصیل' },
  'File Explorer': { EN: 'File Explorer', UR: 'فائل ایکسپلورر' },
  'Empty Folder': { EN: 'This folder is empty.', UR: 'یہ فولڈر خالی ہے۔' },
  'No Results': { EN: 'No results found.', UR: 'کوئی نتیجہ نہیں ملا۔' },
  'Page': { EN: 'Page', UR: 'صفحہ' },
  'Of': { EN: 'of', UR: 'میں سے' },
  'Items': { EN: 'items', UR: 'اشیاء' },
  'Item': { EN: 'item', UR: 'شے' },
  'Member Folder': { EN: 'Member Folder', UR: 'ممبر فولڈر' },
  'Project': { EN: 'Project', UR: 'پروجیکٹ' },
  'Image Viewer': { EN: 'Image Viewer', UR: 'تصویر ویور' },
  'Video Player': { EN: 'Video Player', UR: 'ویڈیو پلیئر' },
  'Open': { EN: 'Open', UR: 'کھولیں' },
  'Notch': { EN: 'In service of the khilafat', UR: 'خدمتِ خلافت ہمارا مقصد' },
};
